import { provideWidgetClass } from "scrivito"

export const MyProfileCardHeaderWidget = provideWidgetClass(
  "MyProfileCardHeaderWidget",
  {
    attributes: {
      content: "widgetlist"
    }
  }
)

export type MyProfileCardHeaderWidgetInstance = InstanceType<
  typeof MyProfileCardHeaderWidget
>
